var _style, _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgC1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1000 1000",
    style: {
      enableBackground: "new 0 0 1000 1000"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M855.7,1000H144.3C64.9,1000,0,935.1,0,855.7V144.3C0,64.9,64.9,0,144.3,0h711.4C935.1,0,1000,64.9,1000,144.3 v711.4C1000,935.1,935.1,1000,855.7,1000z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M645.22,500.74l286.74-286.75c24.06-24.05,24.06-63.22,0-87.57l-58.41-58.38c-24.07-24.05-63.25-24.05-87.61,0L499.2,354.79 L214.07,69.81c-24.07-24.05-63.25-24.05-87.61,0l-58.41,58.38c-24.07,24.05-24.07,63.22,0,87.57l285.13,284.99L68.36,785.29 c-24.07,24.05-24.07,63.22,0,87.56l58.41,58.38c24.07,24.05,63.25,24.05,87.61,0l284.84-284.55l285.42,285.28 c24.07,24.05,63.25,24.05,87.61,0l58.41-58.38c24.07-24.05,24.07-63.22,0-87.57L645.24,500.72L645.22,500.74z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgC1);
export default __webpack_public_path__ + "static/media/c1.45015ea2d6e185aa616b2cdbe99140fb.svg";
export { ForwardRef as ReactComponent };